const positionProvider = (elm: HTMLElement) => {
  const rect = elm.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return { rect, viewHeight };
};

// Check if any part of the element is visible on the page
// Threshold defines how much of the element must be visible to pass the check
export const isElementVisible = (elm: HTMLElement, threshold = 1) => {
  const { rect, viewHeight } = positionProvider(elm);
  return !(rect.bottom < threshold || rect.top + threshold - viewHeight >= 0);
};

// Check if the top of the element is visible on the page
// Threshold defines how much of the top of the element must be visible to pass the check
export const isTopOfElementVisible = (elm: HTMLElement, threshold = 1) => {
  const { rect, viewHeight } = positionProvider(elm);
  return !(rect.top < threshold || viewHeight - rect.top < threshold);
};
